$(document).ready(function(){
  
  // if(JSON.parse(localStorage.getItem('__ui'))[2][1].discountCodeWarning.discountLine.discount.title == 'OFFERTE'){
  //   document.querySelector('.EmailDetails').innerHTML += '<div class="UserOfferAvailed">Offer is alredy availed</div>'
  //   document.querySelector('.NExtSizeSTep').classList.add('DisableNextSteps')
  // }else{
  //   document.querySelector('.NExtSizeSTep').classList.remove('DisableNextSteps');
  //   document.querySelector('.UserOfferAvailed').remove();
  // }
  
  var swiper = new Swiper('.MAindivSeller', {
          
    slidesPerView: 1.18,
    paginationClickable: true,       
    spaceBetween: 16,
    navigation: { nextEl: '.bestsellnext', prevEl: '.bestsellprev', },
    breakpoints: {
      1920: { slidesPerView: 2.176, spaceBetween: 29 },
      1028: { slidesPerView: 2.10, spaceBetween: 16 },
      749: { slidesPerView: 1.18, spaceBetween: 16 },
    },
    on:{
      slideChange: function() {
        setTimeout(function () {
          swiper.params.touchReleaseOnEdges = false;  
          swiper.params.mousewheel.releaseOnEdges = false;
        });
      },
      reachEnd: function() {
        setTimeout(function () {
          swiper.params.touchReleaseOnEdges = true;
          swiper.params.mousewheel.releaseOnEdges = true;
        }, 500);
      },
      reachBeginning: function() {
        setTimeout(function () {
          swiper.params.touchReleaseOnEdges = true;
          swiper.params.mousewheel.releaseOnEdges = true;
        }, 500);
      }
    }
  });


   var mySwiper = new Swiper('.ReviewSection_Wrapper', {
  
      loop: true,
 slidesPerView: 1.18,
  spaceBetween: 14,
    navigation: {
      nextEl: '.RevNext',
      prevEl: '.RevPrev',
    },
              breakpoints: {
            1920: {
            
                slidesPerView: 3.2,              
               spaceBetween: 34
            },
                1140: {
            
                slidesPerView: 3.2,              
               spaceBetween: 34
            },
            1028: {
                slidesPerView: 2.21,
                spaceBetween: 14
            },
            749: {
                
                slidesPerView: 1.5,
                spaceBetween: 14
            }
        }
});


    
});






$(document).ready(function(){

  var products_list = document.querySelectorAll('.FreeProduct .structureXS');
  if(products_list.length > 0){
    products_list.forEach(function(product){
      var selected_size = product.getAttribute('prosize'), selected_color = product.dataset.variantColor, selected_product = product.getAttribute('protitle');
      if(selected_color.trim() != ''){ var combo_selection = selected_color+' / '+selected_size; }
      else{ var combo_selection = selected_size; }
      if(document.querySelector('[HiddenSelectorProducts] option[data-product="'+selected_product+'"][data-title="'+combo_selection+'"]') && product.querySelectorAll('.colorSwatchmgMN').length == 0){
        var availability = document.querySelector('[HiddenSelectorProducts] option[data-product="'+selected_product+'"][data-title="'+combo_selection+'"]').getAttribute('available');
        if(availability == 'false'){
          product.classList.add('soldout')
          product.style.display = 'none'
        }
      }
      if(product.querySelectorAll('.colorSwatchmgMN').length > 0){
        product.querySelectorAll('.colorSwatchmgMN input').forEach(function(color, index){
          if(index == 0){
            color.checked = true;
            var color_images=color.closest('.colorSwatchmgItem').querySelector('.HiddenImagesMN'),
                productId=color.closest('.structureXS').getAttribute('data-product'),
                selectedVariant = document.querySelector('.hiddenVariantMatchSelet[data-productId="'+productId+'"] option[data-title="'+color.value+' / '+selected_size+'"]').value,
                selectedImage = document.querySelector('.hiddenVariantMatchSelet[data-productId="'+productId+'"] option[data-title="'+color.value+' / '+selected_size+'"]').dataset.image;
            color.closest('.structureXS').dataset.variantColor == color.value;
            color.closest('.structureXS').setAttribute('data-variantid',selectedVariant);
            color.closest('.structureXS').setAttribute('data-image',selectedImage);
            if(color_images.querySelectorAll('.hiddenImage')[0]){
              color.closest('.structureXS').querySelectorAll('.FreeProductImage .Wp_combine_mg_cmb .mgSwipeTutorXt')[0].innerHTML = color_images.querySelectorAll('.hiddenImage')[0].innerHTML;
            }
            if(color_images.querySelectorAll('.hiddenImage')[1]){
              color.closest('.structureXS').querySelectorAll('.FreeProductImage .Wp_combine_mg_cmb .mgSwipeTutorXt')[1].innerHTML = color_images.querySelectorAll('.hiddenImage')[1].innerHTML;
            }
            if(color_images.querySelectorAll('.hiddenImage')[2]){
              color.closest('.structureXS').querySelectorAll('.FreeProductImage .Wp_combine_mg_cmb .mgSwipeTutorXt')[2].innerHTML = color_images.querySelectorAll('.hiddenImage')[2].innerHTML;
            }
          }
        })
      }
    })
  }

  $(document).on('click','.swiper-button-prev',function(){
    var flow = $('.Imagesloop.swiper-slide-active').attr('data-flow');
    $('.nextprevbtn .nextBtn').attr('dataGet-flow',flow);
  });

  $(document).on('click','.SizeDescription button',function(){
    setTimeout(function() {
      var flow = $('.Imagesloop.swiper-slide-active').attr('data-flow');
      $('.nextprevbtn .nextBtn').attr('dataGet-flow',flow);
    },500);
  });
  $(document).on('click','.swiper-button-next',function(){
    var flow = $('.Imagesloop.swiper-slide-active').attr('data-flow');
    $('.nextprevbtn .nextBtn').attr('dataGet-flow',flow);
  });

  $(document).on('click','.nextprevbtn .nextBtn',function(){
    var data_val = $(this).attr("dataget-flow");
    var hidden_html = $(".hiddout[datafree-pro='"+data_val+"'] .FreeVerifyProduct").html();
    $(".MainVerify_product[datafree-pro='"+data_val+"'] .FreeVerifyProduct").html(hidden_html);
    setTimeout(function(){
      if($(".MAinFreeProducts.FlowActive").children('.FreeProduct').children('.swiper-slide').hasClass('ACtiveSize')){ $('.NotAvialable').html(" "); }
      else{ $('.NotAvialable').html("<span>This Size is Not Available</span>"); }
    },500)
    var floww = $(this).attr('dataget-flow');
    $('.MAinFreeProducts').removeClass('FlowActive');
    $('.MAinFreeProducts[datafree-pro="'+floww+'"]').addClass('FlowActive');
    $('.VerifyProduct').removeClass('FlowActive');
    $('.VerifyProduct[datafree-pro="'+floww+'"]').addClass('FlowActive');
  });

  var swiper = null;
  
  function initSwiper() {
    if (window.innerWidth <= 768) {
      if (swiper === null) {
        swiper = new Swiper(".IndexBanner", {
         
          slidesPerView: "1.65",
         
         
          spaceBetween: 39,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      }
    } else {
      if (swiper !== null) {
        swiper.destroy();
        swiper = null;
      }
    }
  }

  initSwiper();

  window.addEventListener("resize", function () {
    if (swiper !== null) {
      swiper.destroy();
      swiper = null;
    }
    initSwiper();
  });

  $(document).on('click', '.faqTitle', function(e){
    e.preventDefault();
    $(this).parents('.FaqCard').toggleClass('active').siblings().removeClass('active');
  })



  $('.count').each(function () {
    $(this).prop('Counter',0).animate(
      { Counter: $(this).text() },
      { duration: 5000, easing: 'swing', step: function (now) { $(this).text(Math.ceil(now)); } }
    );
  });


  $('.variantSelect').on('change', function() {
    var selectedValue = $(this).val();
    $(".Bestselleratc").val(selectedValue);
  });
  
  
  
    var mySwiper = new Swiper('.CollectionSlider', {
      loop: true,
      slidesPerView: 1.189,
      spaceBetween: 22,
    navigation: {
      nextEl: '.slider__button-next',
      prevEl: '.slider__button-prev',
    },
              breakpoints: {
            1920: {
            
                slidesPerView: 2.16,              
                spaceBetween: 61
            },
            1028: {
                slidesPerView: 2.21,
                spaceBetween: 22
            },
            749: {
                
                slidesPerView: 1.189,
                spaceBetween: 22
            }
        }
});




});

$(document).ready(function(){
  var $slickActiveDiv = $('.EmailCard div.swiper-slide-active'), htmlContent = $slickActiveDiv.attr("valuesize"), selectsizes = $('.SelectSize').attr('size', htmlContent);
  $(document).on('click','.SizeDescription button', function(){
    var $slickActiveDiv = $('.EmailCard div.swiper-slide-active'), htmlContent = $slickActiveDiv.attr("valuesize"), selectsize = $(this).parents('.SelectSize').attr('size', htmlContent);
    $('.tamponsCard').css('display','block');
    $('.SizeSelectedTsep').css('display','none');
    $('.AllOverMail').css('display','none');
    $('.FreeProduct .swiper-slide').each(function(){
      var fetchsize = $(this).attr('prosize');
      if(htmlContent == fetchsize){
        $(this).addClass('ACtiveSize');
        $(this).removeClass('removeACtiveSize');
      }else{
        $(this).removeClass('ACtiveSize');
        $(this).addClass('removeACtiveSize');      
      }
    })
    $('.hiddout .FreeVerifyProduct .swiper-slide').each(function(){
      var fetchsize = $(this).attr('prosize');
      if(htmlContent == fetchsize){
        $(this).addClass('ACtiveSize');
        $(this).removeClass('removeACtiveSize');
      }else{
        $(this).removeClass('ACtiveSize');
        $(this).addClass('removeACtiveSize');
      }
    });
    $('.MainVerify_product .FreeVerifyProduct .swiper-slide').each(function(){
      var fetchsize = $(this).attr('prosize');
      if(htmlContent == fetchsize){
        $(this).addClass('ACtiveSize');
        $(this).removeClass('removeACtiveSize');
      }else{
        $(this).removeClass('ACtiveSize');
        $(this).remove();
      }
    })
    var mySwiper = new Swiper('.tamponsCard', {
      slidesPerView: 1,
      navigation: { nextEl: '.slider__button-next', prevEl: '.slider__button-prev' },
      breakpoints: {
        1920:{ slidesPerView: 1, },
        1028:{ slidesPerView: 1, },
        749:{ slidesPerView: 1, }
      }
    });
  })

  $(document).on('click','.nextprevButtonss .nextBtn',function(){
    var $slickActiveDiv = $('.EmailCard div.swiper-slide-active'),htmlContent = $slickActiveDiv.attr("valuesize"), 
        data_color=$slickActiveDiv.attr('data-color'),selectsize = $(this).parents('.SelectSize').attr('size', htmlContent), available_products=[],
        final_products_list = document.querySelectorAll('.VerifyProductWrapper');

    const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
      const { top, left, bottom, right } = el.getBoundingClientRect();
      const { innerHeight, innerWidth } = window;
      return partiallyVisible
        ? ((top > 0 && top < innerHeight) ||
            (bottom > 0 && bottom < innerHeight)) &&
            ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
        : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
    };
    document.querySelectorAll('.MAinFreeProducts.FlowActive .structureXS.ACtiveSize').forEach(function(item){
      var itemProductId= item.getAttribute('data-product');
      document.querySelectorAll('.MainVerify_product .FreeVerifyProduct .swiper-slide').forEach(function(nextItem){
        var fetchsize = nextItem.getAttribute('prosize');
        if(htmlContent == fetchsize){
          var next_itemId=nextItem.getAttribute('productid');
          if(itemProductId == next_itemId){
            var itemVariantID = document.querySelector('.MAinFreeProducts.FlowActive .structureXS.ACtiveSize[data-product="'+next_itemId+'"]').dataset.variantid,
                itemImage = document.querySelector('.MAinFreeProducts.FlowActive .structureXS.ACtiveSize[data-product="'+next_itemId+'"]').dataset.image,
                product_title = nextItem.getAttribute('protitle'),
                available = document.querySelector('[HiddenSelectorProducts] option[data-product="'+product_title+'"][value="'+itemVariantID+'"]').getAttribute('available');
            nextItem.setAttribute('proid',itemVariantID);
            nextItem.setAttribute('data-image',itemImage);
            nextItem.querySelector('.verifyallimages img').src = itemImage;
            nextItem.querySelector('.VerifyATcbutton [name="id"]').value = itemVariantID;
            setTimeout(function(){
              if(elementIsVisibleInViewport(nextItem, true) == true){
                available_products.push(nextItem)
              }
            }, 400)
            if(available == 'false'){
              nextItem.remove();
              nextItem.classList.add('soldout')
              nextItem.style.display = 'none'
            }
          }
        }

      })
    })

    setTimeout(function(){
      document.querySelector('#applyDiscountButton').setAttribute('getid',available_products[available_products.length - 1].getAttribute('proid'));
    }, 400)
  
    $('.tamponsCard').css('display','block');
    $('.SizeSelectedTsep').css('display','none');
    $('.AllOverMail').css('display','none');
    $('.MainVerify_product .FreeVerifyProduct .swiper-slide').each(function(){
      var fetchsize = $(this).attr('prosize');
      if(htmlContent == fetchsize){
        $(this).addClass('ACtiveSize');
        $(this).attr('data-color',data_color);
        $(this).removeClass('removeACtiveSize');
      }else{
        $(this).removeClass('ACtiveSize');
        $(this).remove();
      }
    });
  });
  
  $(document).on('click','.nextprevbtn .nextBtn',function(){     
    $('.MAinFreeProduct').css('display','block');
    $('.tamponsCard').css('display','none');
    $('.SizeSelectedTsep').css('display','none');
    $('.AllOverMail').css('display','none');
    
    var MainFreePDsSlider = new Swiper('.MAinFreeProducts', {
      slidesPerView: 1,
      allowTouchMove: false,
      navigation: { nextEl: '.slider__button-next', prevEl: '.slider__button-prev', },
      breakpoints: {
        1920: { slidesPerView: 1 },
        1028: { slidesPerView: 1 },
        749: { slidesPerView: 1 }
      },
      on:{
        init:function(swiper){
          $('.nextprevButtonss .nextBtn').attr('data-index',swiper.realIndex);
        },
        slideChange: function(swiper){
          $('.nextprevButtonss .nextBtn').attr('data-index',swiper.realIndex);
        }
      }
    });
  })

  var swatchColor = document.querySelectorAll('.colorSwatchmgItem');
  if(swatchColor.length){
    swatchColor.forEach(function(color){
      color.querySelector('input').addEventListener('change',function(e){
        e.preventDefault();
        var color_name=this.value, color_images=this.closest('.colorSwatchmgItem').querySelector('.HiddenImagesMN'),
            sizeSelected=this.closest('.structureXS').getAttribute('prosize'),
            productId=this.closest('.structureXS').getAttribute('data-product'),
            comboVariant = color_name+' / '+sizeSelected, 
            selectedVariant = document.querySelector('.hiddenVariantMatchSelet[data-productId="'+productId+'"] option[data-title="'+comboVariant+'"]').value,
            selectedImage = document.querySelector('.hiddenVariantMatchSelet[data-productId="'+productId+'"] option[data-title="'+comboVariant+'"]').dataset.image;
        this.closest('.structureXS').setAttribute('data-variant-color',color_name);
        this.closest('.structureXS').setAttribute('data-variantid',selectedVariant);
        this.closest('.structureXS').setAttribute('data-image',selectedImage);
        this.closest('.NExtSizeSTep').querySelector('.SizeSelectedTsep .EmailCard div.swiper-slide-active').setAttribute('data-color',color_name);
        if(color_images.querySelectorAll('.hiddenImage')[0]){
          this.closest('.structureXS').querySelectorAll('.FreeProductImage .Wp_combine_mg_cmb .mgSwipeTutorXt')[0].innerHTML = color_images.querySelectorAll('.hiddenImage')[0].innerHTML;
        }
        if(color_images.querySelectorAll('.hiddenImage')[1]){
          this.closest('.structureXS').querySelectorAll('.FreeProductImage .Wp_combine_mg_cmb .mgSwipeTutorXt')[1].innerHTML = color_images.querySelectorAll('.hiddenImage')[1].innerHTML;
        }
        if(color_images.querySelectorAll('.hiddenImage')[2]){
          this.closest('.structureXS').querySelectorAll('.FreeProductImage .Wp_combine_mg_cmb .mgSwipeTutorXt')[2].innerHTML = color_images.querySelectorAll('.hiddenImage')[2].innerHTML;
        }
      })
    })
  }
    
  $(document).on('click','.nextprevbtn .PreviousBtn',function(){     
    $('.MAinFreeProduct').css('display','none');
    $('.tamponsCard').css('display','none');
    $('.SizeSelectedTsep').css('display','block');
    $('.AllOverMail').css('display','none');         
  });
  
  
  $(document).on('click','.nextprevButtonss .nextBtn',function(){
    const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
      const { top, left, bottom, right } = el.getBoundingClientRect();
      const { innerHeight, innerWidth } = window;
      return partiallyVisible
        ? ((top > 0 && top < innerHeight) ||
            (bottom > 0 && bottom < innerHeight)) &&
            ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
        : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
    };
    var dataIndex = $(this).attr('data-index');
    $('.VerificationSection').css('display','block');
    $('.MAinFreeProduct').css('display','none');
    $('.tamponsCard').css('display','none');
    $('.SizeSelectedTsep').css('display','none');
    $('.AllOverMail').css('display','none');  
    $('.CompleteOrder').addClass('activeSection');
    $('.FreeBagWrapper').css('display','none');
    var finalPdsSlider = new Swiper('.VerifyProduct', {
      slidesPerView: 1,
      navigation: { nextEl: '.slider__button-next',prevEl: '.slider__button-prev' },
      breakpoints: {
        1920: { slidesPerView: 1, },
        1028:{ slidesPerView: 1, },
        749:{ slidesPerView: 1, }
      },
      on:{
        init: function(swiper){
          swiper.slideTo(dataIndex)
        },
      }
    });
    // finalPdsSlider.slideTo(dataIndex)
  })
  $(document).on('click','.nextprevButtonss .PreviousBtn',function(){
    $('.VerificationSection').css('display','none');
    $('.MAinFreeProduct').css('display','none');
    $('.tamponsCard').css('display','block');
    $('.SizeSelectedTsep').css('display','none');
    $('.AllOverMail').css('display','none'); 
    $('.CompleteOrder').removeClass('activeSection');
  })
});

$(function() {
  var loc = window.location.href;  
  if(loc.indexOf("offer_availed_user") > -1 ){
  }else{
    if( loc.indexOf('customer_posted=true#contact_form') !== -1 || loc.indexOf('customer_posted=true') !== -1 || loc.indexOf('form_type=customer') !== -1){
    $('body').addClass('Flow_Willbe_goingNow');
    $('.NExtSizeSTep').removeClass('hidden');
    $('.SizeSelectedTsep').css('display', 'block');
    $('.AllOverMail').css('display', 'none');

     var mySwiper = new Swiper('.SelectSize', {
  
     
 slidesPerView: 1,
 
    navigation: {
      nextEl: '.slider__button-next',
      prevEl: '.slider__button-prev',
    },
              breakpoints: {
            1920: {
            
                slidesPerView: 1,              
                
            },
            1028: {
                slidesPerView: 1,
                
            },
            749: {
                
                slidesPerView: 1,
                
            }
        }
});

      document.querySelector('.Index_EmailSection').scrollIntoView({behavior:'smooth'});
    }
  }
});


$(document).ready(function($) {
    $('.allOverFreeBAg').find('.Arrowsvg').click(function(){
$('.allOverFreeBAg').toggleClass('Activearrow');
      var isActive = $(this).hasClass("active");
			$('.Arrowsvg').removeClass('active')
      if (!isActive) {
        $(this).toggleClass('active');
      }
         
      $(this).next().slideToggle('fast');     
      //Hide the other panels
      $(".SlideContent").not($(this).next()).slideUp('fast');

    });
  
  });


  $(document).ready(function () {
  
  var gtt = $('.FreeVerifyProduct div').attr("proid");
 
  var aaa = $('.InnerOffere #applyDiscountButton').attr('getid', gtt);



  const discountCodeInput = $('#discountCodeInput');
  const applyDiscountButton = $('#applyDiscountButton');

  applyDiscountButton.click(function () {
    const enteredCode = discountCodeInput.val().trim();
   var test = $('.InnerOffere #applyDiscountButton').attr('getid');

      var clickt = $('.FreeVerifyProduct div.swiper-slide-active').attr("proid");

   // var dynid = $(this).attr('getid',clickt);

    if (enteredCode.indexOf('OFFERTE') >-1) {
       window.location.href = 'https://www.mool.fr/cart/'+ clickt +':1?checkout&discount=OFFERTE';
     
    } else {
      alert('Invalid code');
    }
  });

  $(document).on('click',".disnext",function(){
    var very = $('.VerifyProductWrapper').attr('protitle'), gtt = $('.VerifyProduct:visible .FreeVerifyProduct div.swiper-slide-active').attr("proid")
    $(this).parents('.VerificationSection .VerifyOuterdiv').children('.StaticOffer').children('.InnerOffere').children('#applyDiscountButton').attr('getid',gtt);
  });

  $(document).on('click',".disprev",function(){
    var very = $('.VerifyProductWrapper').attr('protitle'), gtt = $('.VerifyProduct:visible .FreeVerifyProduct div.swiper-slide-active').attr("proid")
    $(this).parents('.VerificationSection .VerifyOuterdiv').children('.StaticOffer').children('.InnerOffere').children('#applyDiscountButton').attr('getid',gtt);
  });

 $('.OverlayEnabvled').on('mouseenter', function() {
      $('.OverlayEnabvled').removeClass('OverlayEnabvled'); 
  });


  });


$(document).on('click', '.RebootText', function(e){
  e.preventDefault();
  setTimeout(function () {
      var data_val = $(".MainVerify_product:visible").attr("datafree-pro");
  var hidden_html = $(".hiddout[datafree-pro='"+data_val+"'] .FreeVerifyProduct").html();
  console.log(hidden_html);
   $(".MainVerify_product[datafree-pro='"+data_val+"'] .FreeVerifyProduct").html(hidden_html);

      $('.tamponsCard').css('display','none');
   $('.MAinFreeProduct').css('display','none');
   $('.VerificationSection').css('display','none');
   $('.SizeSelectedTsep').css('display','block');
  },1200);



})

$(document).on('click', '.Wp_combine_mg_cmb', function(e){
  e.preventDefault();
  $(this).parents('.FreeallImage').append(this);
})


